import { render, staticRenderFns } from "./InaugurationView.vue?vue&type=template&id=bc4b0306"
import script from "./InaugurationView.vue?vue&type=script&lang=js"
export * from "./InaugurationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports